import React from 'react';
import { BrowserRouter } from 'react-router-dom';
import { Provider } from 'react-redux';
import configureStore from './store/configureStore';
import registerLoader from './registerLoader';
import './styles/main.css';
import App from './components/App';
import 'babel-polyfill';
import ReactDOM from 'react-dom/client'; // Correct import

const store = configureStore();
const rootNode = document.getElementById('root');

// Create a root with createRoot
const root = ReactDOM.createRoot(rootNode);

// Render your application
const rootComponent = (
  <Provider store={store}>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </Provider>
);

// Use the root to render
root.render(rootComponent);

registerLoader();
